module.exports = __webpack_public_path__ + "static/media/cn.a94c9394.svg";